import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MEFuelInUse from "../../components/Vessel/VesselPerformance/MEFuelInUse";
import NavigationData from "../../components/Vessel/VesselPerformance/NavigationData";
import AEData from "../../components/Vessel/VesselPerformance/AEData";
import RemainingFuelOnboard from "../../components/Vessel/VesselPerformance/RemainingFuelOnboard";
import EnginePowerGraph from "../../components/Vessel/VesselPerformance/EnginePowerGraph";
import EngineSFOCGraph from "../../components/Vessel/VesselPerformance/EngineSFOCGraph";
import FuelConsumptionChart from "../../components/Vessel/VesselPerformance/FuelConsumptionChart";
import DateRangePicker from "../../components/Common/DateRangePicker";
import BDNDropdown from "../../components/Vessel/VesselPerformance/BDNDropdown";
import VesselHeader from "../../components/Vessel/VesselHeader";
import {
  getVesselPerformanceMetaData,
  getVesselPerformanceFuelConsumption,
  getVesselPerformanceFuelRemaining,
  getVesselPerformanceMainEnginePower,
  getVesselPerformanceSfocEfficiency,
  getVesselPerformanceDetails,
} from "../../services/vesselService";
import VoyageFilter from "../../components/Common/VoyageFilter";
import { setSelectedbdnId } from "../../store/bdnIdSlice";
import { setSelectedVoyage } from "../../store/voyageFilterSlice";

const VesselPerformance = () => {
  const dispatch = useDispatch()
  const { startDate, endDate } = useSelector((state) => state.dateRange);
  const { currentVessel } = useSelector((state) => state.vesselOverview);
  const { selectedbdnId } = useSelector((state) => state.bdnId)
  const { selectedVoyage } = useSelector((state) => state.voyageFilter);
  const [bdnDisabled, setBdndisabled] = useState(false);
  const [dateRangeDisabled, setDateDisabled] = useState(false);
  const [vesselData, setVesselData] = useState(null);

  const [vesselMetaData, setVesselMetaData] = useState(null);
  const [fuelConsumption, setFuelConsumption] = useState(null);
  const [fuelRemaining, setFuelRemaining] = useState(null);
  const [mainEngine, setMainEngine] = useState(null);
  const [sfocEfficiencyData, setSfocEfficiency] = useState(null);

  const [loading, setLoading] = useState(true);

  const fetchPerformanceData = async (
    vesselId = currentVessel?._id || currentVessel?.id,
    start = startDate,
    end = endDate,
    bdn = selectedbdnId,
    voyageId = selectedVoyage?._id
  ) => {
    if (!vesselId) return;

    try {
      setLoading(true);
      const { data } = await getVesselPerformanceDetails(vesselId);
      console.log("Performance Data:", data);
      setVesselData(data);

      const metaData = await getVesselPerformanceMetaData(vesselId, start, end, bdn, voyageId);
      console.log("Meta Data:", metaData);
      setVesselMetaData(metaData);

      const fuelConsumption = await getVesselPerformanceFuelConsumption(vesselId, start, end, bdn, voyageId);
      setFuelConsumption(fuelConsumption);

      const fuelRemaining = await getVesselPerformanceFuelRemaining(vesselId, start, end, bdn, voyageId);
      setFuelRemaining(fuelRemaining);

      const mainEnginePower = await getVesselPerformanceMainEnginePower(vesselId, start, end, bdn, voyageId);
      setMainEngine(mainEnginePower);

      const sfocEfficiency = await getVesselPerformanceSfocEfficiency(vesselId, start, end, bdn, voyageId);
      setSfocEfficiency(sfocEfficiency);

    } catch (error) {
      console.error("Failed to fetch performance data:", error);
    } finally {
      setLoading(false);
    }
  };

  function normalizeFuelType(fuelType) {
    console.log("change fuel format", fuelType);
    if (!fuelType || typeof fuelType !== "string") return fuelType;
    return fuelType.replace(/-BDN-/, "-F-");
  }


  useEffect(() => {
    console.log("selectedVoyage", selectedVoyage)
    console.log("bdn_id", selectedbdnId)
    console.log("currentVessel", currentVessel)
    if (currentVessel?._id && selectedVoyage == null) {
      setBdndisabled(false)
      setDateDisabled(false)
      fetchPerformanceData(currentVessel._id, startDate, endDate, selectedbdnId, selectedVoyage);
    } else {
      if (selectedVoyage?._id) {
        setBdndisabled(true)
        setDateDisabled(true)
        fetchPerformanceData(currentVessel._id, null, null, null, selectedVoyage?.voyageId);
      }
    }
  }, [currentVessel, startDate, endDate, selectedbdnId, selectedVoyage]);

  // Reset bdnId only when vessel changes
  useEffect(() => {
    if (currentVessel?._id) {
      dispatch(setSelectedbdnId(null));
      dispatch(setSelectedVoyage(null));
    }
  }, [currentVessel]);

  return (
    <div className="relative">

      <div className="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between mb-6">
        <VesselHeader pageTitle="Performance Analytics" />

        <div className="flex gap-2">
          <VoyageFilter />
          {/* <BDNDropdown  disabled={bdnDisabled}/> */}
          <DateRangePicker disabled={dateRangeDisabled} />
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">Loading...</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-4 mt-6">
          {/* Top Row */}
          <div className="col-span-3 flex gap-4 items-stretch">
            <MEFuelInUse
              fuelId={normalizeFuelType(vesselMetaData?.meFuelData.fuelId) || 0}
              sulfurContent={vesselMetaData?.meFuelData.sulfurContent || 0}
              consumption={vesselMetaData?.meFuelData.meFuelCons || 0}
              power={vesselMetaData?.meFuelData.fuelPower || 0}
              // fuel_type={vesselMetaData?.meFuelData?.mefuelType || "N/A"}
              fuel_type={vesselMetaData?.allFuelTypes?.meFuelTypes || "N/A"}
            />
            <AEData
              fuelId={normalizeFuelType(vesselMetaData?.aeFuelData.fuelId) || 0}
              fuelConsumption={vesselMetaData?.aeFuelData.aeFuelCons || 0}
              sulfurContent={vesselMetaData?.aeFuelData.sulfurContent || 0}
              totalPower={vesselMetaData?.aeFuelData.totalPower}
              fuel_type={vesselMetaData?.allFuelTypes?.aeFuelTypes || "N/A"}
            />
            {/* <NavigationData
              gpsSpeed={vesselMetaData?.navigationData.gpsSpeed || 0}
              logSpeed={vesselMetaData?.navigationData.logSpeed || 0}
              distance={vesselMetaData?.navigationData.distance || 0}
              rudderAngle={vesselMetaData?.navigationData.rudderAngle || 0}
              headWind={vesselMetaData?.navigationData.heading || 0}
            /> */}
          </div>

          {/* Middle Row */}
          <div className="col-span-3 flex gap-4 items-stretch">
            <FuelConsumptionChart
              consumptionHistory={fuelConsumption || []}
            />
            <RemainingFuelOnboard remainingFuel={fuelRemaining || []} />
          </div>

          {/* Bottom Rows */}
          <div className="col-span-3 flex gap-4 items-stretch">
            <EnginePowerGraph enginePower={mainEngine || []} />
            <EngineSFOCGraph sfocEfficiency={sfocEfficiencyData || []} />
          </div>
        </div>
      )}
    </div>
  );
};

export default VesselPerformance;
